//libs
import { connect } from 'react-redux';

//components
import ShareLink from './ShareLink';

//redux-store-selectors
import { getProductTitle, getProductUrl } from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => ({
  title: getProductTitle(state),
  url: getProductUrl(state),
});

export default connect(mapStateToProps)(ShareLink);
